import { Phone, Sparkles, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const aiPhoneCallsForProactiveOutreachCampaignsAr: TemplateAr = {
  name: 'مكالمات ذكية لحملات التواصل الاستباقي',
  description:
    'مكالمات آلية جماعية بالذكاء الاصطناعي للإعلانات والعروض وتحديثات الخدمة على نطاق واسع.',
  category: 'المكالمات بالذكاء الاصطناعي',
  workflow: [
    { icon: Users, label: 'قائمة الحملة' },
    { icon: Sparkles, label: 'اتصال ذكي' },
    { icon: Phone, label: 'الحملة اكتملت', final: true },
  ],
  detailDescription: {
    paragraph1:
      'أعلن الجديد لعملائك بمكالمة، مو بإشعار جماعي. الـ AI يتصل بمئات أو آلاف العملاء، يعلن عن مزايا جديدة، أو يشارك عرضاً، أو ينبّه على تغيير في الخدمة، أو يسأل عن حالهم. وكل مكالمة مخصصة بسياق العميل نفسه.',
    paragraph2:
      'نتائج الحملة، وطلبات إلغاء الاشتراك، وردود العملاء، كلها تتابعها في الـ CRM أو منصة أتمتة التسويق عندك. والـ AI يعدّل الرسالة حسب أنماط الاستجابة لحظياً. والعميل المهتم يتحوّل للمبيعات أو الدعم تلقائياً.',
  },
  benefits: [
    'توصل لآلاف العملاء بشكل شخصي',
    'كل محادثة مخصصة، على نطاق واسع',
    'تتبع أداء حملتك لحظياً',
    'الـ AI يرصد العميل المهتم تلقائياً',
    'توفّر كماً هائلاً من وقت الاتصال',
    'تختبر صيغ الرسائل تلقائياً',
  ],
};
